var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute20240716235245(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0c1c3c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.19,102.57c-1.69,0-3.33-.62-4.65-1.82l-26.91-24.44c-.51-.46-1.17-.72-1.86-.72H10.27c-5.03,0-9.11-4.08-9.11-9.11v-29.5c0-5.03,4.08-9.11,9.11-9.11h25.49c.69,0,1.35-.26,1.86-.72L64.4,2.83c1.55-1.41,3.64-2.22,5.71-1.9,3.65.58,6.05,3.46,6.05,6.88v87.57c0,2.16-.84,4.33-2.56,5.65-1.36,1.04-2.9,1.54-4.42,1.54ZM33.95,31.27m30.87-27.21h0m.58-.06h.01-.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute20240716235245);
export default __webpack_public_path__ + "static/media/UNMUTE-20240716-235245.908dd58462cb8cf4cbc60e274715a8eb.svg";
export { ForwardRef as ReactComponent };